import React, { Fragment, useEffect } from "react"
import { sendPrintRequest } from "utils"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import { deletePrintRequest } from "@redux"
import PlShiftPrintTemplate from "./PrinterTemplates/PlShiftPrintTemplate"
import PlTestPrintTemplate from "./PrinterTemplates/PlTestPrintTemplate"
import PlQrPrintTemplate from "./PrinterTemplates/PlQrPrintTemplate"
import PlTableMovedPrintTemplate from "./PrinterTemplates/PlTableMovedPrintTemplate"
import PlCombinedOrdersPrintTemplate from "./PrinterTemplates/PlCombinedOrdersPrintTemplate"
import PlOrderDeletedPrintTemplate from "./PrinterTemplates/PlOrderDeletedPrintTemplate"
import PlOrderPrintTemplateForCustomer from "./PrinterTemplates/PlOrderPrintTemplateForCustomer"
import PlOrderPrintTemplateForKitchen from "./PrinterTemplates/PlOrderPrintTemplateForKitchen"
import PlOrderItemsPrintTemplate from "./PrinterTemplates/PlOrderItemsPrintTemplate"
import PlOrderEditedPrintTemplate from "./PrinterTemplates/PlOrderEditedPrintTemplate"
import PlOrderItemPerQuantityPrintTemplate from "./PrinterTemplates/PlOrderItemPerQuantityPrintTemplate"
import classes from "./PlCapture.module.scss"

const PlCapture = (props) => {
  const { printRequest } = props

  const {
    reject,
    resolve,
    printType,
    printData,
    printerSettings,
    templateType,
    printRequestId
  } = printRequest

  const dispatch = useDispatch()

  const i18n = useTranslation()[1]

  const handleCapture = async () => {
    const captures =
      document.querySelectorAll(`#capture-${printRequestId}`)

    let htmls = []

    captures.forEach(capture => {
      htmls.push(capture.innerHTML)
    })

    if (!printerSettings.printerCutter) {
      htmls = [htmls.join("")]
    }

    const data = {
      htmls,
      templateType,
      printRequest,
      language: i18n.language,
      dir: i18n.dir(i18n.language)
    }

    try {
      await sendPrintRequest(data)

      resolve()
    } catch (err) {
      reject(err)
    }

    dispatch(
      deletePrintRequest(printRequestId)
    )
  }

  useEffect(() => {
    handleCapture()
  }, [])

  return (
    <div className={classes["container"]}>
      {
        printType === "test" &&
        <div id={`capture-${printRequestId}`}>
          <PlTestPrintTemplate
            templateType={templateType}
            forPos={printerSettings.forPos}
            printerWidth={printerSettings.printerWidth}
          />
        </div>
      }
      {
        printType === "tableQrCode" &&
        <div id={`capture-${printRequestId}`}>
          <PlQrPrintTemplate
            printData={printData}
            templateType={templateType}
            forPos={printerSettings.forPos}
            printerWidth={printerSettings.printerWidth}
          />
        </div>
      }
      {
        printType === "shift" &&
        <div id={`capture-${printRequestId}`}>
          <PlShiftPrintTemplate
            printData={printData}
            templateType={templateType}
            forPos={printerSettings.forPos}
            printerWidth={printerSettings.printerWidth}
          />
        </div>
      }
      {
        printType === "tableMoved" &&
        <div id={`capture-${printRequestId}`}>
          <PlTableMovedPrintTemplate
            printData={printData}
            templateType={templateType}
            forPos={printerSettings.forPos}
            printerWidth={printerSettings.printerWidth}
          />
        </div>
      }
      {
        printType === "combinedOrder" &&
        <div id={`capture-${printRequestId}`}>
          <PlCombinedOrdersPrintTemplate
            printData={printData}
            templateType={templateType}
            forPos={printerSettings.forPos}
            printerWidth={printerSettings.printerWidth}
          />
        </div>
      }
      {
        printType === "deletedOrder" &&
        <div id={`capture-${printRequestId}`}>
          <PlOrderDeletedPrintTemplate
            printData={printData}
            templateType={templateType}
            forPos={printerSettings.forPos}
            printerWidth={printerSettings.printerWidth}
          />
        </div>
      }
      {
        printType === "order" &&
        <Fragment>
          {
            printData.printCustomerReceipt &&
            <div id={`capture-${printRequestId}`}>
              <PlOrderPrintTemplateForCustomer
                printData={printData}
                templateType={templateType}
                forPos={printerSettings.forPos}
                printerWidth={printerSettings.printerWidth}
              />
            </div>
          }
          {
            printData.printKitchenReceipt &&
            printData.thisPrinterOrderItems.length > 0 &&
            <div id={`capture-${printRequestId}`}>
              <PlOrderPrintTemplateForKitchen
                printData={printData}
                templateType={templateType}
                forPos={printerSettings.forPos}
                printerWidth={printerSettings.printerWidth}
                thisPrinterOrderItems={printData.thisPrinterOrderItems}
              />
            </div>
          }
          {printData.printPerItems.map((thisPrinterOrderItem, oiIndex) =>
            <div key={oiIndex} id={`capture-${printRequestId}`}>
              <PlOrderItemsPrintTemplate
                printData={printData}
                thisPrinterOrderItem={thisPrinterOrderItem}
                templateType={templateType}
                forPos={printerSettings.forPos}
                printerWidth={printerSettings.printerWidth}
              />
            </div>
          )
          }
          {printData.printPerItemQuantity.map((thisPrinterOrderItem, oiIndex) =>
            <div key={oiIndex} id={`capture-${printRequestId}`}>
              <PlOrderItemPerQuantityPrintTemplate
                printData={printData}
                thisPrinterOrderItem={thisPrinterOrderItem}
                templateType={templateType}
                forPos={printerSettings.forPos}
                printerWidth={printerSettings.printerWidth}
              />
            </div>
          )
          }
        </Fragment>
      }
      {
        printType === "orderEdited" &&
        <div id={`capture-${printRequestId}`}>
          <PlOrderEditedPrintTemplate
            printData={printData}
            templateType={templateType}
            forPos={printerSettings.forPos}
            printerWidth={printerSettings.printerWidth}
          />
        </div>
      }
    </div>
  )
}

export default PlCapture